/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hide[_ngcontent-%COMP%]{display:none}.help.is-danger[_ngcontent-%COMP%]{font-size:12px;margin-bottom:0;margin-top:0;color:#e65252!important}"];
export { styles as styles };
